import React from 'react';

import CampaignReviewSummary from '../../components/CampaignReviewSummary';
import { EmailCampaignFormValues } from '../../types';

import styles from './CampaignSummaryPanel.module.scss';

interface CampaignSummaryPanelProps {
    values: EmailCampaignFormValues;
    /** Resolved recipient count post-exclusions — propagated from the wizard. */
    recipientTotal: number;
}

/**
 * Sits below `SendTimePanel` in Step 3's left column. Renders a compact,
 * read-only review of what the wizard has captured so far so the user can
 * sanity-check before opening the commit modal — honours the step's name
 * ("Review & Send") and fills the empty space the original design left.
 *
 * `Send` row is intentionally hidden here because the Send Time controls are
 * already visible above; the modal re-includes the row at commit time.
 */
const CampaignSummaryPanel: React.FC<CampaignSummaryPanelProps> = ({ values, recipientTotal }) => {
    return (
        <div className={styles.root}>
            <h3 className={styles.heading}>Review</h3>
            <CampaignReviewSummary
                values={values}
                recipientTotal={recipientTotal}
                includeSendTime={false}
            />
        </div>
    );
};

export default CampaignSummaryPanel;
